import React from "react";
import "../../css/SettingsModal.css";
import { THEMES } from "../../theme/themes";

export default function SettingsModal({
  open,
  selectedThemeId,
  onSelect,
  onApply,
  onClose
}) {
  if (!open) return null;

  return (
    <div className="settings-overlay" onClick={onClose}>
      <div className="settings-modal" onClick={(e) => e.stopPropagation()}>
        <div className="settings-modal-header">
          <div>
            <div className="settings-title">Theme Settings</div>
          </div>
          <button className="settings-close" onClick={onClose} aria-label="Close settings">
            X
          </button>
        </div>

        <div className="settings-theme-list">
          {THEMES.map((theme) => {
            const active = theme.id === selectedThemeId;
            return (
              <button
                key={theme.id}
                className={`settings-theme-row${active ? " selected" : ""}`}
                onClick={() => onSelect(theme.id)}
              >
                <span
                  className="settings-theme-swatch"
                  style={{
                    background: `linear-gradient(90deg, ${theme.bg1}, ${theme.bg2})`,
                    borderColor: active ? theme.accent : "#d8d8e0"
                  }}
                />
                <span className="settings-theme-name">{theme.name}</span>
                <span className="settings-theme-arrow">{" >"}</span>
              </button>
            );
          })}
        </div>

        <div className="settings-footer">
          <button className="settings-apply" onClick={onApply}>
            Apply Theme
          </button>
        </div>
      </div>
    </div>
  );
}
